import React from 'react'
import { useNavigate } from 'react-router-dom'

import { ButtonContainer, PageTitle, SinglePanePage } from 'styles/shared'
import styled from 'styled-components'
import { color } from 'styles/colors'

import Modal from 'components/Modal'
import { Button } from '@nexiahome/ui-common/components/primitives/buttons'

const ORACLE_ACCOUNT_INACTIVE_MESSAGE = 'Your Oracle account must be active before enabling it for HVAC Performance Monitoring Kits.'

const HEHMOracleInactiveModal = () => {
  const navigate = useNavigate()
  const onClickClose = () => {
    navigate(-1)
  }

  return (
    <S.Modal variant="sm" isDisplayed closeCallback={onClickClose} title="" paperStyles={{ borderRadius: '16px', backgroundColor: 'transparent' }}>
      <S.PageTitle>Account in Oracle Not Active</S.PageTitle>
      <S.SinglePanePage>
        <S.Explanation>{ORACLE_ACCOUNT_INACTIVE_MESSAGE}</S.Explanation>
        <S.ButtonContainer>
          <Button decoration="positive"
                  text="OK"
                  onPress={onClickClose}
                  styles={{ button: { height: 32, borderRadius: 5, width: 86, backgroundColor: color('billingButton') } }}
          />
        </S.ButtonContainer>
      </S.SinglePanePage>
    </S.Modal>
  )
}

export default HEHMOracleInactiveModal

const S = {
  ButtonContainer: styled(ButtonContainer)`
    border-top: none;
    margin-top: 0px;
  `,
  Explanation: styled.div`
    display: flex;
    font-weight: bold;
    text-align: center;
    color: ${color('premiumText')};
    white-space: pre-line;
  `,
  Modal: styled(Modal)`
    background-color: ${color('hehmAccentLight')};
    border: 1px solid ${color('inactiveAccountModalBorder')};
    border-radius: 16px;
  `,
  PageTitle: styled(PageTitle)`
    display: block;
    font-size: 32px;
    margin-top: 20px;
    margin-bottom: 10px;
    text-align: center;
    text-transform: none;
    text-wrap: auto;
  `,
  SinglePanePage: styled(SinglePanePage)`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 0px;
    background-color: ${color('hehmAccentLight')};
  `
}
